/**
 * Typed user-scoped API functions (Voxcanon theme preference today).
 *
 * Routes here are auth-required but NOT company-scoped, so they don't take
 * a CompanyApi argument — they hit the global `api` client directly.
 */

import { isVoxThemeKey } from "@lexicanon/shared"
import type { TVoxTheme } from "../theme-mode.ts"
import { api } from "./client.ts"
import { unwrap } from "./errors.ts"

// The shared theme endpoint can hold either product's value; narrow to a
// Voxcanon surface here (a Lexicanon key reads as "no Voxcanon choice").
function toVoxTheme(value: unknown): TVoxTheme | null {
  return isVoxThemeKey(value) ? value : null
}

export async function fetchUserThemePreference(): Promise<TVoxTheme | null> {
  const response = unwrap(await api.api.users.me.theme.get())
  return toVoxTheme(response.data.theme)
}

export async function updateUserThemePreference(theme: TVoxTheme | null): Promise<TVoxTheme | null> {
  const response = unwrap(await api.api.users.me.theme.put({ theme }))
  return toVoxTheme(response.data.theme)
}
